<template>
  <div class="yxtbiz-common-selector">
    <div class="clearfix font-size-14">
      <div class="pull-left">
        <yxt-select clearable v-if="type === -1" v-model="commonType" class="mr12" :placeholder="typePlaceholder" style="width:144px;" @change="getList(true)">
          <yxt-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></yxt-option>
        </yxt-select> 
      </div>
      <yxt-input style="width:240px;"
        class="pull-left"
        :placeholder="searchPlaceholder"
        v-model="searchParam.keyword"
        searchable
        maxlength="50"
        @search="search"
      >
      </yxt-input>
    </div>
    <div class="yxtbiz-common-selector__main mt16">
      <yxt-table ref="stb"
        class="yxtbiz-common-selector__table"
        @select-all="selectAll"
        @select="select"
        v-loading="loading"
        :data="list"
        :height='tableHeight'
        :default-sort="{prop: 'updateTime',  order: 'desc'}"
        @sort-change="sortChange"
      >
        <yxt-table-column v-if="!isSingle" :show-overflow-tooltip='false' class-name="yxtbiz-table-selection" type="selection" width="39"></yxt-table-column>
        <yxt-table-column
            v-for="(column, index) in columns"
            :key="index"
            :prop="column.name"
            :label="column.label || column.name"
            :width="column.width"
            show-overflow-tooltip>
            <template slot-scope="scope">
                <span>{{ multiColumn(column.isCombined ? column.factors : [column], scope.row) }}</span>
            </template>
        </yxt-table-column>
        <yxt-table-column v-if="isSingle" label="操作" width="100" align="left">
          <template slot-scope="scope">
            <yxt-link
              @click="selectRow(scope.row)"
              :underline="false"
              type="primary"
            >{{ value && (value.id === scope.row.id || (value[0] && value[0].id === scope.row.id))? "取消选择" : "选择" }}</yxt-link>
          </template>
        </yxt-table-column>
      </yxt-table>
      <div class="mt16 clearfix pr">
        <yxt-pagination
          class="pull-right"
          :page-size="searchParam.limit"
          :total="count"
          :current-page="page"
          layout="total, prev, pager, next"
          @current-change="pageChange"
          @size-change="sizeChange"
        ></yxt-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getList, getTopicList } from './service';
import dateUtil from 'yxt-biz-pc/src/utils/date';
import resizeTable from '../../user-selector/mixins/resizeTable';
import {
  Pagination,
  Link,
  Table,
  TableColumn,
  Select,
  Option
} from 'yxt-pc';

const pageSize = 20;
const TOPIC_TYPES = {
  '0': '装修专题',
  '1': '链接专题'
};

export default {
  name: 'YxtbizCommonSelector',
  components: {
    YxtPagination: Pagination,
    YxtLink: Link,
    YxtTable: Table,
    YxtTableColumn: TableColumn,
    YxtSelect: Select,
    YxtOption: Option
  },
  mixins: [resizeTable],
  props: {
    value: {
      type: Array | Object,
      default: () => {
        return {};
      }
    },
    resultType: {
      type: String,
      default: 'teacher'
    },
    type: {
      type: Number,
      default: -1
    },
    // 是否强制单选模式， 默认会根据传入的数据类型修改。true时强制单选模式
    singleMode: {
      type: Boolean,
      default: false
    },
    functionCode: {
      type: String,
      default: ''
    },
    dataPermissionCode: {
      type: String,
      default: ''
    },
    typePlaceholder: { // 类型placeHolder
      type: String,
      default: '类型'
    },
    searchPlaceholder: { // 搜索placeHolder
      type: String,
      default: '请输入姓名/账号搜索'
    },
    options: { // 下拉框选项
      type: Array,
      default: () => {
        return [];
      }
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      }
    },
    getListApi: {
      type: String,
      default: '/external/te/select'
    }
  },
  data() {
    return {
      page: 1,
      refTable: 'stb',
      tableHeight: 0,
      searchParam: {
        type: -1,
        queryType: 1,
        keyword: '',
        keywordType: 0,
        limit: pageSize,
        offset: 0,
        orderby: 'updateTime',
        direction: 'DESC',
        navCode: this.functionCode,
        dataPermissionCode: this.dataPermissionCode
      },
      loaded: 1,
      loading: false,
      totalPage: 0,
      count: 0,
      list: [], // 列表
      commonType: '', // 选择类型
      selected: {},
      isSingle: true, // m2只有单选模式
      isSingleVal: true
    };
  },
  computed: {
    topicData() {
      let result = {
        limit: pageSize,
        offset: (this.page - 1) * pageSize,
        keyword: this.searchParam.keyword.trim(),
        status: 1,
        type: this.type === -1 ? (this.commonType || -1) : this.type
      };

      return result;
    }
  },
  created() {
    this.isSingleVal = !this.value || (!this.value.length && this.value.length !== 0);
    this.isSingle = this.singleMode || this.isSingleVal;
    this.formatModel(this.value);
    this.getList();
  },
  methods: {
    shortDate(row, col, val, index) {
      if (!val) return '';
      return dateUtil.format(new Date(val), 'yyyy-MM-dd');
    },
    filterNode(value, data) {
      return !value || data.label.indexOf(value) !== -1;
    },
    getList(isReset) {
      this.loading = true;
      if (this.resultType === 'topic') {
        this.getTopicList(isReset);
      } else {
        if (isReset) {
          this.page = 1;
          this.searchParam.offset = 0;
        }
        this.searchParam.type = this.type === -1 ? (this.commonType || -1) : this.type;
        this.searchParam.keyword = this.searchParam.keyword.trim();
        getList(this.getListApi, this.searchParam)
          .then(result => {
            this.list = result.datas;
            this.totalPage = result.paging.pages;
            this.count = result.paging.count;
            this.loaded--;
            this.loading = false;
            this.$nextTick(() => {
              this.setChecked();
            });
          })
          .catch(e => {
            console.log(e);
          });
      }
    },
    getTopicList(isReset) {
      if (isReset) {
        this.page = 1;
      }
      getTopicList(this.topicData).then(res => {
        this.list = res.datas;
        this.totalPage = res.paging.pages;
        this.count = res.paging.count;
        this.loading = false;
        this.$nextTick(() => {
          this.setChecked();
        });
      });
    },
    search() {
      this.getList(true);
    },
    sortChange(sort) {
      this.searchParam.direction = sort.order;
      this.searchParam.orderby = sort.prop;
      this.getList();
      return false;
    },
    sizeChange(size) {
      this.searchParam.limit = size;
      this.getList(true);
    },
    pageChange(page) {
      this.page = page;
      this.searchParam.offset = (page - 1) * this.searchParam.limit;
      this.getList();
    },
    selectRow(item) {
      if (this.isSingleVal) {
        if (this.value && this.value.id === item.id) {
          this.$emit('input', null);
          this.$emit('select', null);
        } else {
          this.$emit('input', item);
          this.$emit('select', item);
        }
      } else {
        // 兼容之前的多选模式的数组型数据源
        if (this.value.length > 0 && this.value[0].id === item.id) {
          this.$emit('input', []);
          this.$emit('select', []);
        } else {
          this.$emit('input', [item]);
          this.$emit('select', [item]);
        }
      }
    },
    // 选择某个
    select(item, row) {
      let isAdd = item.some(v => {
        return v.id === row.id;
      });
      if (!isAdd) {
        delete this.selected[row.id];
      } else {
        this.selected[row.id] = row;
      }
      this.outPut();
    },
    // 全选
    selectAll(items) {
      let isAdd = items.length !== 0;
      this.list.forEach(obj => {
        if (!isAdd) {
          delete this.selected[obj.id];
        } else {
          this.selected[obj.id] = obj;
        }
      });
      this.outPut();
    },
    // 删除已选择
    deleteItem(item) {
      let row = item;
      for (let index = 0; index < this.list.length; index++) {
        const element = this.list[index];
        if (element.id === item.id) {
          row = element;
          break;
        }
      }
      if (row) {
        this.$refs['stb'].toggleRowSelection(row, false);
      }
      delete this.selected[item.id];
      this.$forceUpdate();
      this.outPut();
    },
    // 清空
    clear() {
      let row = null;
      for (const key in this.selected) {
        if (this.selected.hasOwnProperty(key)) {
          for (let index = 0; index < this.list.length; index++) {
            const element = this.list[index];
            if (element.id === key) {
              row = element;
              break;
            }
          }
          if (row) {
            this.$refs['stb'].toggleRowSelection(row, false);
          }
        }
      }
      this.selected = {};
      this.outPut();
    },
    // 输出的数据
    outPut() {
      const selArray = Object.values(this.selected);
      this.$emit('input', selArray);
      this.$emit('select', selArray);
    },
    setChecked() {
      this.list.forEach(obj => {
        if (this.selected.hasOwnProperty(obj.id)) {
          this.$refs['stb'].toggleRowSelection(obj, true);
        } else {
          this.$refs['stb'].toggleRowSelection(obj, false);
        }
      });
    },
    formatModel(v) {
      this.selected = {};
      if (v) {
        if (this.isSingle) {
          if (v.id) {
            this.selected[v.id] = v;
          }
        } else {
          v.forEach(obj => {
            this.selected[obj.id] = obj;
          });
        }
      }
    },
    getTopicType(type) {
      return TOPIC_TYPES[type] || '-';
    },
    multiColumn(factors, row) {
      return factors.map((factor) => {
        if (row[factor.name] === undefined || row[factor.name] === null || row[factor.name] === '-') return '-';
        if (this.resultType === 'topic' && factor.name === 'type') return this.getTopicType(row[factor.name]);
        return row[factor.name];
      }).join(' / ');
    }
  },
  watch: {
    value(v) {
      this.formatModel(v);
      this.setChecked();
    }
  }
};
</script>
